export default __webpack_public_path__ + "static/7-81b95886ea9a95421174536b70ed59e1.jpg";